import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserVM } from 'app/Models/UserVM';
import { LoginService } from 'app/landing/login.service';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { ThemeService } from 'app/shared/theme/theme.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportCount } from 'app/Models/ReportCountDto';
import { Subscription } from 'rxjs';
import { ReportingService } from '../reporting-service.service';
import { CurrentUser } from 'app/Models/CurrentUser';
@Component({
  selector: 'app-report-home',
  templateUrl: './report-home.component.html',
  styleUrls: ['./report-home.component.scss']
})
export class ReportHomeComponent implements OnInit {
  lastRefresh: boolean = true;
  breakpoint: any;
  isApprovalQueue: boolean = false;
  isMobileDevice: boolean = false;
  defaultDateFormat: string;
  loggedInUser: UserVM;
  reportCount: ReportCount[];
  getReportCountSubscription: Subscription;
  roleId: number = CurrentUser.RoleId;
  constructor(public sharedService: SharedServicesService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private themeService: ThemeService,
    private restService: ReportingService,
    private router: Router
  ) {
    this.sharedService.activeLink = 'Home';
    this.loggedInUser = JSON.parse(sessionStorage.getItem('resource'));
    this.themeService.sendData(this.loggedInUser.DefaultTheme);
    this.defaultDateFormat = !this.loggedInUser.DefaultDateFormat ||
      this.loggedInUser.DefaultDateFormat == 'System date format'
      ? sharedService.getLocalDateFormat() : this.loggedInUser.DefaultDateFormat;
  }

  loggedinUser: any;
  count: any;
  ngOnInit(): void {
    this.spinner.show();
    this.getReportCount();
  }
  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 2;
  }
  getReportCount() {
    this.reportCount = [];
    this.getReportCountSubscription =
      this.restService.GetReportCount(this.roleId).subscribe(
        (data) => {
          this.spinner.hide();
          this.reportCount = data;
        }
      );
  }
}
